import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '~components/typography';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.flex.crossCenter,
    padding: '8px 12px',
    color: theme.colors.grey66,
    borderRadius: 16,
    backgroundColor: theme.colors.greyE8,
    '& > *:first-child': { marginRight: 8 },
  },
}));

function ContentHeaderSelectReadOnly(props) {
  const { Icon, title } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Icon />
      <Typography variant="h6" themeColor="grey66">
        {title}
      </Typography>
    </div>
  );
}

ContentHeaderSelectReadOnly.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  title: PropTypes.node.isRequired,
};

export default ContentHeaderSelectReadOnly;
